<template>


  <div v-if="showgreet" class="hello">
    <b-jumbotron style="margin:auto;width:100%;max-width:700px" container-fluid bg-variant="light">
      <h1>{{lang == 'en' ? 'Test' : 'Teszt'}} </h1>
      <p>
      {{lang == 'en'? "The test will start after you pressed the start button. You won't see the orange button in advance anymore, it's up to you to decide which dog was the bigger. ":

      'A tényleges teszt a start gomb megnyomása után indul. A továbbiakban nem jelezzük narancssárgával a helyes választ, hanem neked kell eldöntened, szerinted melyik kutya volt a nagyobb méretű.'}}
    </p>

    <p>
    {{lang == 'en'? 'Please click on the button which belongs to the larger dog (after the click you will still have the opportunity to change your mind.) When you are ready, click on the "Next" button.)':

    'Kérjük, mindig kattints arra a gombra, ami a szerinted nagyobb kutya hangjához tartozik, (a kattintás után még lesz lehetőséged megváltoztatni a döntésed). Ha kész vagy, kattints a kék tovább gombra!.'}}
  </p>
        <b-button variant = "primary" style="margin-top:25px" @click="start">{{lang == 'en'? 'Start': 'Start'}}</b-button>
    </b-jumbotron>

  </div>
  <div v-else class="hello">
    <b-jumbotron style="margin:auto;width:100%;max-width:700px" container-fluid bg-variant="light">
      <h1> {{lang == 'en' ? 'Which one is larger?' : 'Melyik a nagyobb?'}} </h1>
      <h2> {{lang == 'en' ? 'Test: ' : 'Teszt: '}} {{soundcounter + 1}}/45 </h2>
      <b-row>
        <b-col>
          <b-button
          :variant="left_variant"
          @click = "choose_sound('left')"
          size = "lg"
          style = "margin-top:25px"
            >
            <faicon icon="dog" :size="left_size"/>
            </b-button>
        </b-col>
        <b-col>
          <b-button
          @click = "choose_sound('right')"
          :variant="right_variant"
          size = "lg"
          style = "margin-top:25px"
          >
            <faicon icon="dog" :size="right_size"/>
          </b-button>
        </b-col>
      </b-row>
        <p style = "margin-bottom:50px" v-if = "show_buttons">
          {{lang == 'en' ? 'Please choose!' : 'Kérjük, válassz!'}}
        </p>




        <b-button
          v-if = "show_buttons"
          style="margin: 5px;"
          variant = "primary"
          @click="listen_again()"

        >
          {{lang == 'en' ? 'Listen again' : 'Meghallgatom újra' }}
        </b-button>
        <p>
          <b-button
            :variant = "nextvariant"
            v-if = "show_buttons"
            style="margin: 5px;"
            @click = "next()"
          >
            {{lang == 'en' ? 'Next' : 'Tovább' }}
          </b-button>
        </p>
    </b-jumbotron>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'



export default {
  name: 'demo',
  computed: mapState([
    'lang',
    'measurements',
    'demos',
    '_id'
  ]),
  data () {
    return {
			soundlist: [],
			audio_objects: [],
      soundcounter: 0,
      show_buttons: false,
      left_variant: 'secondary',
      left_size: '1x',
      right_variant: 'secondary',
      right_size: '1x',
      start_side:'left',
      chosen_side: 'none',
      first_chosen_side: 'none',
      time_loaded: 0, //mount loads
      time_user_start: 0, //when we give control back to the user
      time_first_choice: 0,
      time_last_listen_end: 0,
      count_choices: 0, //number of time user chooses
      count_listen: 0, //number of time user hears the sounds
      time_last_choice: 0, //time of the last click
      isblocked: false,
      nextvariant: "secondary",
      showgreet: true,
    }
  },
  methods: {
    ...mapMutations(['addMeasurement','addDemo']),
    choose_sound(side){
      if (this.isblocked) return 1;
      this.count_choices += 1
      var current_time = window.performance.now()
      if (this.count_choices == 1) {
        this.time_first_choice = current_time
        this.first_chosen_side = side
      }
      this.time_last_choice = current_time
      this.nextvariant = 'primary'
      if (side == 'left'){
        this.chosen_side = 'left'
        this.left_size = '3x'
        this.right_size = '1x'
      }
      else{
        this.left_size = '1x'
        this.right_size = '3x'
        this.chosen_side = 'right'
      }
    },
    play(){
      if (this.isblocked) return 1;
      this.count_listen += 1;
      this.isblocked = true
			//var sounds = this.soundlist[this.soundcounter];
			//var audio1 = new Audio(sounds[0])
			//var audio2 = new Audio(sounds[1])
			console.log("hi", this.soundcounter)
      var audio1 = this.audio_objects[this.soundcounter][0];
      var audio2 = this.audio_objects[this.soundcounter][1];
      var audio2play = audio2.play.bind(audio2) //the fuck?
      this.left_variant = "secondary"
      this.right_variant = "secondary"
      if (this.start_side == 'left') {
        this.left_variant = 'success'
        audio2.onended = () => {
          this.isblocked = false
          this.left_variant = "primary"
          this.right_variant = "primary"
          this.show_buttons = true
          var current_time = window.performance.now()
          if (this.countlisten == 1) this.time_user_start = current_time;
          this.time_last_listen_end = current_time
        }
        audio1.onended = () => {
          this.left_variant = 'secondary'
          setTimeout(audio2play,1000)
          this.right_variant = 'success'
        }
      }
      else{
        this.right_variant = 'success'
        audio2.onended = () => {
          this.isblocked = false
          this.left_variant = "primary"
          this.right_variant = "primary"
          this.show_buttons = true

          var current_time = window.performance.now()
          if (this.countlisten == 1) this.time_user_start = current_time;
          this.time_last_listen_end = current_time
        }
        audio1.onended = () => {
          this.right_variant = 'secondary'
          setTimeout(audio2play,1000)
          this.left_variant = 'success'
        }
      }
      audio1.play()
      return 0
    },
  listen_again(){
    this.play()
  },
  reset(){
    this.left_variant = "secondary"
    this.right_variant = "secondary"
    this.isblocked = false
    this.show_buttons = false
    this.nextvariant = "secondary"
    this.right_size = "1x"
    this.left_size = "1x"
    this.chosen_side = "none"
    this.first_chosen_side = "none"
    this.count_choices = 0
    this.count_listen = 0
    this.time_user_start = 0
    this.time_last_choice = 0
    this.time_first_choice = 0
    this.time_last_listen_end = 0

  },
  save_measurement(){
    var current_time = window.performance.now()
    var res = {
      start_side: this.start_side,
      sound1: this.soundlist[this.soundcounter][0].replace('/api/static/testsounds/',''),
      sound2: this.soundlist[this.soundcounter][1].replace('/api/static/testsounds/',''),
      chosen_side: this.chosen_side,
      first_chosen_side: this.first_chosen_side,
      count_choices: this.count_choices,
      count_listen: this.count_listen,
      total_time: current_time - this.time_loaded,
      total_user_time: current_time - this.time_user_start,
      time_until_last_choice: this.time_last_choice - this.time_user_start,
      time_until_first_choice: this.time_first_choice - this.time_user_start,
      time_since_last_listen: current_time - this.time_last_listen_end,
      currentstamp: Date.now(),
      demo: false
    }

    console.log(res)
    this.addDemo(res)
    this.$http.post('/api/addMeasurement',{'_id':this._id,'measurement':res}).then(
      res => {
        if (res.body.status == 'ok'){
          console.log(res.body)
        }
      },
      res => {console.log('err')}
    )
    console.log(this.measurements)
  },
  next(){
    if (this.chosen_side == "none") return 1;
    if (this.isblocked) return 1;

    this.save_measurement()

    this.soundcounter += 1
    if (this.soundcounter == 45) {
      this.$router.push("thankyou")
    }
    else{
      this.reset()
      this.start_side = this.start_side = Math.random() < 0.5 ? "left" : "right"
      this.play()
    }

  },

    start(){
      var audioplaypause = async function (i,q,prom,t_)  {
        await prom
        t_.audio_objects[i][q].pause()
        t_.audio_objects[i][q].currentTime = 0;
      }
      for (var i = 0; i < this.soundlist.length;i++){
        var audioelem = [new Audio(this.soundlist[i][0]),new Audio(this.soundlist[i][1])];
        this.audio_objects.push(audioelem);
      }
      audioplaypause(0,0,this.audio_objects[0][0].play(),this)
      audioplaypause(0,1,this.audio_objects[0][1].play(),this)
      this.time_loaded = window.performance.now();
      this.showgreet = false;
      setTimeout(this.play,1000);
  },

  },
  mounted () {
    this.$http.get('/api/testsounds').then(response => {
       this.soundlist = response.body;
       console.log("soundlist: ", this.soundlist)
       this.start_side = Math.random() < 0.5 ? "left" : "right"
       //this.time_loaded = window.performance.now();
       //setTimeout(this.play,1000);
     }, response => {
       // error callback
     });


  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>
